// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_css-loader_lib_css-base_js-node_modules_css-loader_lib_url_escape_js-nod-8b1f87"], function() { return __webpack_require__("./css/index.css"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
